exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox-subs[data-v-cba7dd0a]{gap:10px!important}.checkbox-subs input[data-v-cba7dd0a]{width:23px!important;margin-right:0!important}.checkbox-subs span[data-v-cba7dd0a]{padding-bottom:10px!important;font-size:18px!important;font-weight:400!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cba7dd0a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/frontend/js/components/WindCave.vue
// module id = cZUm
// module chunks = 1